

<template>


    <van-button :disabled="StorePkNbFibre"  class="all_border_radius btn_reset_config btn-select-config" size="large"  @click="resetConfiguration" type="primary">
      <van-icon name="replay" class="font_24" />
    
      <span class="btn-reset-text font_12">
      Reset
     </span>
    </van-button>




          </template>
  
          <script>
        import { showToast } from 'vant';
          export default {
            components: {
             
            },
            data() {
              return {

              }
            },
            methods: {
              onSelect(action){
      showToast(action.text);
    } ,
              resetConfiguration(){
                this.$store.commit('REMOVE_CHOICE_CABLE')
                this.$store.commit('REMOVE_CHOICE_COA')
                this.$store.commit('REMOVE_CHOICE_COB')
                this.$store.commit('REMOVE_CHOICE_LONGUEUR')
                this.$store.commit('REMOVE_CHOICE_CABLE')
                this.$store.commit('REMOVE_CHOICE_CHAUSSETTE')
                
              },
       
            },
            created(){
            },
            computed: {
              /** Nombre de fibre */
              StorePkNbFibre() {
                return this.globalFunction.existKeyInArray("nombre", this.$store.state.storeCable.cable) 
                ? false
                : true 
            },
            }
          
          
          }
  </script>